export function Footer() {
  return (
    <footer className="border-t border-[var(--line)] px-6 py-[34px]">
      <div className="mx-auto flex max-w-[1200px] flex-wrap items-center justify-between gap-3.5 text-[13.5px] text-dim">
        <span>© 2026 Northforge Solutions</span>
        <span>Built for businesses buried in admin.</span>
      </div>
    </footer>
  );
}
